import React from 'react';
export default function FlowerCrownSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 22C6 22 10 18 20 18C30 18 34 22 34 22" stroke="#43A047" strokeWidth="2" fill="none" />
      <circle cx="10" cy="16" r="4" fill="#E91E63" /><circle cx="10" cy="16" r="2" fill="#FCE4EC" />
      <circle cx="20" cy="14" r="4" fill="#FFB300" /><circle cx="20" cy="14" r="2" fill="#FFF8E1" />
      <circle cx="30" cy="16" r="4" fill="#7B1FA2" /><circle cx="30" cy="16" r="2" fill="#E1BEE7" />
      <circle cx="15" cy="15" r="3" fill="#42A5F5" /><circle cx="15" cy="15" r="1.5" fill="#BBDEFB" />
      <circle cx="25" cy="15" r="3" fill="#EF5350" /><circle cx="25" cy="15" r="1.5" fill="#FFCDD2" />
    </svg>
  );
}
